export const UploadOnCallDocumentsPage = (
  destinationLang
) => {
  return [
    {
      FormKey: 'upload-oncall-documents-navbar-title',
      Key: 'مشاهده و ارسال مدارک درمانگر',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'upload-oncall-documents-radio-picture',
      Key: 'تصوير',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'complete-user-information-navbar-title',
      Key: 'تکيمل اطلاعات',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'upload-oncall-documents-radio-file',
      Key: 'فايل',
      DistinitationLanguage: destinationLang,
    },

    {
      FormKey: 'upload-oncall-documents-btn-send-documents',
      Key: 'ارسال مدارک',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'upload-oncall-documents-btn-show-documents',
      Key: 'مشاهده مدارک',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'upload-oncall-documents-btn-document-select',
      Key: 'مدرک',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-check-select-expiry-date',
      Key: 'انتخاب تاريخ انقضا',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'upload-oncall-documents-select-document-type-select',
      Key: 'نوع مدرک',
      DistinitationLanguage: destinationLang,
    },
  ];
};
